import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

function Navbar1() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [shouldRenderOverlay, setShouldRenderOverlay] = useState(false);
  const location = useLocation();

  const isHomePage = location.pathname === '/';

  // ✅ Navbar class logic
  const navClass = menuOpen ? 'navbar white' : isHomePage ? 'navbar white' : 'navbar black';

    const logoSrc = (isHomePage || menuOpen) 
    ? '/homeimage/white.png'  // 👉 white logo file
    : '/homeimage/black.png'; // 👉 black logo file

  const toggleMenu = () => {
    if (menuOpen) {
      setMenuOpen(false);
      setTimeout(() => setShouldRenderOverlay(false), 1000);
    } else {
      setShouldRenderOverlay(true);
      setTimeout(() => setMenuOpen(true), 100);
    }
  };

  return (
    <>
      <nav className={navClass}>
         <div className="logo">
          <Link to="/" className="logo-link">
            <img src={logoSrc} alt="MyLogo" className='navlog'/>
          </Link>
        </div>
        <div className={`burger ${menuOpen ? 'open' : ''}`} onClick={toggleMenu}>
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
        </div>
      </nav>

      {shouldRenderOverlay && (
        <div className={`overlay ${menuOpen ? 'open' : ''}`}>
          <ul>
            <li className={menuOpen ? 'slide-in delay-1' : 'slide-out'}>
              <Link to="/projects" onClick={toggleMenu}>Projects</Link>
            </li>
            <li className={menuOpen ? 'slide-in delay-2' : 'slide-out'}>
              <Link to="/news" onClick={toggleMenu}>News</Link>
            </li>
            <li className={menuOpen ? 'slide-in delay-3' : 'slide-out'}>
              <Link to="/contact" onClick={toggleMenu}>Contact</Link>
            </li>
            <li className={menuOpen ? 'slide-in delay-4' : 'slide-out'}>
              <Link to="/about" onClick={toggleMenu}>About</Link>
            </li>
          </ul>
        </div>
      )}
    </>
  );
}

export default Navbar1;
